import React from 'react'
import { Flex, Box } from "reflexbox" 
import { CSSTransition } from 'react-transition-group';

import "./modal.css"

import { ModalContainer, 
         ModalBoxCSS, 
         ModalOverlay, 
         Header, 
         Message,
         ModalFooter,
         ModalButton,
         HeaderText,
         HeaderButton,
        } from './modal.css.js'

const Modal = (props) => {
    const { title, content } = props.message

    return (
      <CSSTransition in={props.visible} timeout={500} classNames="modal-transition" unmountOnExit>
        <Flex css={ModalContainer}>
          <Flex className="column" css={ModalBoxCSS}>
            <Box css={Header}>
              <h1 css={HeaderText}>{title}</h1>
              <HeaderButton onClick={props.hideModal}></HeaderButton>
            </Box>
            <Box css={Message}>
              {content}
            </Box>
            <Box css={ModalFooter}>
              <ModalButton onClick={props.hideModal}>
                                <span>
                                    OK
                                </span>
              </ModalButton>
            </Box>
          </Flex>
          <ModalOverlay onClick={props.hideModal}>

          </ModalOverlay>
        </Flex>
      </CSSTransition>
    )
}

export default Modal